import { createContext, useContext, useState, useMemo, ReactNode } from 'react';
import { Spin } from 'antd';

export interface ILoadingContext {
    isLoading: boolean;
    isFullScreenLoading: boolean;
    setIsLoading: (loading: boolean) => void;
    setIsFullScreenLoading: (loading: boolean) => void;
}

export const LoadingContext = createContext<ILoadingContext>({
    isLoading: false,
    isFullScreenLoading: false,
    setIsLoading: () => {},
    setIsFullScreenLoading: () => {},
});

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isFullScreenLoading, setIsFullScreenLoading] = useState(false);

    const value = useMemo(
        () => ({
            isLoading,
            isFullScreenLoading,
            setIsLoading,
            setIsFullScreenLoading,
        }),
        [isLoading, isFullScreenLoading]
    );

    return (
        <LoadingContext.Provider value={value}>
            {isFullScreenLoading && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'var(--rm-mask)',
                        backdropFilter: 'blur(2px)',
                        WebkitBackdropFilter: 'blur(2px)',
                        zIndex: 9999,
                    }}
                >
                    <Spin size="large" />
                </div>
            )}
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => useContext(LoadingContext);
